// extracted by mini-css-extract-plugin
export default {"mainContainer":"Layout_mainContainer__RZh6R","mainContent":"Layout_mainContent__Jq0B2"};